import React from "react";
import { ActionButton } from "../../../../../../Common/Buttons/ActionButton";
import { Text as TextInput } from "../../../../../../Inputs";
import {
  ActionButtonContainer,
  InputContainer,
  LabelContainer,
  LVLabel,
  OptionsContainer,
} from "./__styles__/WidgetSettings";

const LabelValueOptionsInput = ({
  dropdownOptions,
  setDropdownOption,
  removeDropdownOption,
  valueEditingDisabled = false,
  disabled,
}: {
  dropdownOptions: Array<{ label: string; value: string }>;
  setDropdownOption: (index: number, label: string, value: string) => void;
  removeDropdownOption: (index: number) => void;
  valueEditingDisabled?: boolean;
  disabled: boolean;
}) => {
  return (
    <div data-testid="label-value-options-input-wrapper">
      <LabelContainer>
        <LVLabel text={"Label"} />
        <LVLabel text={"Value"} />
      </LabelContainer>
      {dropdownOptions.map((option, index) => (
        <OptionsContainer key={`option.${index}`}>
          <InputContainer>
            <TextInput
              onChange={label =>
                setDropdownOption(
                  index,
                  label,
                  valueEditingDisabled ? option.value : label,
                )
              }
              name={`label.${index}`}
              value={option.label}
              disabled={disabled}
            />
          </InputContainer>
          <TextInput
            name={`value.${index}`}
            disabled={!option.label || valueEditingDisabled || disabled}
            value={option.value}
            onChange={value => setDropdownOption(index, option.label, value)}
          />
          <ActionButtonContainer
            hidden={dropdownOptions.length === 1 || disabled}
          >
            <ActionButton
              icon="x"
              onClick={() => removeDropdownOption(index)}
            />
          </ActionButtonContainer>
        </OptionsContainer>
      ))}
    </div>
  );
};

export default LabelValueOptionsInput;
